export default "__VITE_ASSET__Cv0wS2_6__"